<!-- 推广员注册服务协议（邀请下级推广员注册时） -->
<template>
  <div class="privacy_out">
    <div class="privacy_x">
      <div class="txt_title txt_title0 txt_bold">线上推广人员协议规范</div>
      <div class="txt_title txt_bold txt_br2">成都太行云梯科技有限公司</div>
      <!-- <div class="txt_indent txt_br1">
        欢迎使用太行启翼平台，维保业务一站式高效管理系统。
      </div> -->

      <div>一、协议目的</div>
      <div class="txt_indent txt_br1">
        为规范 ERP 系统推广人员（以下简称“推广人员”）的推广行为，明确双方权利义务，保障成都太行云梯科技有限公司（以下简称“公司”）及客户合法权益，特制定本协议。推广人员须在线签署并遵守本协议内容后方可开展推广活动。
      </div>
      
      <div>二、推广人员定义与资格</div>
      <div>1. 分级定义</div>
      <div class="txt_indent">
        一级推广人员：包括股东公司相关人员及经公司审核批准的其他人员，享有直接生成推广二维码的权限。
      </div>
      <div class="txt_indent">
        二级推广人员：由一级推广人员开发的下级销售人员，其推广二维码需通过一级推广人员生成。
      </div>
      <div>2. 资格审核</div>
      <div class="txt_indent">
        所有推广人员需通过公司资质审核，并完成实名认证。
      </div>
      <div class="txt_indent txt_br1">
        公司有权随时取消存在虚假宣传、侵犯公司或客户利益等违规行为人员的推广资格。
      </div>

      <div>三、推广权限与工具</div>
      <div>1. 推广二维码管理</div>
      <div class="txt_indent">
        一级推广人员由公司统一下发唯一推广二维码；二级推广人员由一级推广人员生成并分配二维码。
      </div>
      <div class="txt_indent">
        推广人员可在线上线下宣传材料中使用二维码，但不得擅自修改或转让他人。
      </div>
      <div class="txt_indent">
        若推广资格被取消，二维码将自动失效。
      </div>
      <div>2. 推广场景</div>
      <div class="txt_indent txt_br1">
        客户通过扫描二维码完成注册、下单及支付（以下合称“成交”），系统自动关联推广人员业绩。
      </div>


      <div>四、销售奖金规则</div>
      <div>1. 佣金计算</div>
      <div class="txt_indent">
        直接成交订单：按成交金额的一定比例提取销售奖金（一级、二级推广人员均可享有，具体以公司奖励政策为准）。
      </div>
      <div class="txt_indent">
        间接成交订单：二级推广人员成交的订单，其对应一级推广人员可按成交金额的一定比例提取间接奖金（具体以公司奖励政策为准）。
      </div>
      <div>2. 支付条件</div>
      <div class="txt_indent txt_br1">
        无违规记录且客户无退单争议的成交订单，佣金通过平台账户发放，推广人员需绑定有效收款账户。
      </div>
     
      <div>五、行为规范与违规处理</div>
      <div>1. 禁止行为</div>
      <div class="txt_indent">
        虚假宣传、夸大产品功能或隐瞒服务条款。
      </div>
      <div class="txt_indent">
        擅自修改合同条款、价格或优惠规则。
      </div>
      <div class="txt_indent">
        擅自收取客户款项。
      </div>
      <div class="txt_indent">
        泄露客户隐私或公司商业机密。
      </div>
      <div>2. 违规处理</div>
      <div class="txt_indent">
        首次违规：警告并暂停佣金发放，限期整改。
      </div>
      <div class="txt_indent txt_br1">
        严重违规或二次违规：立即取消推广资格，冻结未结佣金，并追究法律责任。
      </div>

      <div>六、协议生效与终止</div>
      <div>1. 生效条件</div>
      <div class="txt_indent">
        推广人员在线签署本协议后自动生效。
      </div>
      <div>2. 终止情形</div>
      <div class="txt_indent">
        推广人员主动申请退出且完成信息及资料交接的。
      </div>
      <div class="txt_indent">
        公司因业务调整终止的或推广人员违规取消资格的。
      </div>
      <div class="txt_indent txt_br1">
        协议终止后，推广人员须立即停止使用公司标识及推广工具。
      </div>

      <div>七、附则</div>
      <div>1. 本协议解释权归成都太行云梯科技有限公司所有。</div>
      <div class="txt_br1">2. 公司有权根据业务需求修订协议内容，修订后的协议将通过平台公告通知，推广人员继续参与即视为同意新条款。</div>

      <div>签署人确认：</div>
      <div>我已阅读并完全理解本协议内容，自愿遵守所有条款，并承诺合法合规开展推广活动。</div>
      <div class="txt_br1">说明：本协议为线上签署文件，推广人员确认后该协议生效。</div>

      <div class="txt_indent last_time">
        <div>成都太行云梯科技有限公司</div>
        <div>2025 年 4 月 23 日</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.last_time {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 50px;
}
.privacy_out {
  width: 100%;
  box-sizing: border-box;
}
.privacy_x {
  margin: 0 auto;
  padding: 32px 32px 64px 32px;
  max-width: 1000px;
  font-size: 15px;
  line-height: 24px;
  background: #fff;
  white-space: pre-wrap;
  word-break: break-all;
}

.txt_title {
  font-size: 17px;
  text-align: center;
  padding-bottom: 30px;
}
.txt_title0 {
  padding-bottom: 4px;
}

.txt_indent {
  text-indent: 2em;
}
.txt_indent2 {
  text-indent: 2em;
  margin-left: 2em;
}

.txt_bold {
  font-weight: bold;
}

.txt_red {
  color: #b7282d;
}

.txt_br1 {
  margin-bottom: 32px;
}

.txt_br2 {
  margin-bottom: 8px;
}
</style>